export default () => {
    const getPropertiesFromArray = (properties: string[], context: any) => {
        return properties.reduce((acc, prop) => {
            acc[prop] = context[prop];
            return acc;
        }, {});
    };

    const logChangedProperties = (prevValues, properties, currentValues) => {
        const changedProps = [];
        properties.forEach((prop) => {
            if (prevValues[prop] !== currentValues[prop]) {
                changedProps.push(prop);
            }
        });

        console.log('Changed properties:', changedProps);

        return currentValues;
    };

    return {
        getPropertiesFromArray,
        logChangedProperties,
    };
};
